import request from "./request";

//素材制作信息
export const getPros = (data) => request("/pro/getPros", data, "POST_JSON");
export const getDesigner = () => request("/material/getDesigner", null, "GET");
export const getProductor = () => request("/material/getProductor", null, "GET");
export const queryMaterial = (data) => request("/material/queryMaterial", data, "POST_JSON");
export const addMatreial = (data) => request("/material/addMatreial", data, "POST_JSON");
export const modifyMaterial = (data) => request("/material/modifyMaterial", data, "POST_JSON");
// 获取制作小组
export const getProductorList = () => request("/material/getProductorList", null, "GET");
// 添加、修改制作小组
export const addProductor = (data) => request("/material/addProductor", data, "POST_JSON");
// 删除制作小组
export const delProductor = (data) => request("/material/delProductor", data, "POST");
// 获取自定义素材尺寸列表
export const geMaterialSizeList = () => request("/material/materialSizeList", null, "post");
// 修改，添加自定义素材尺寸
export const addMaterialSize = (data) => request("/material/addMaterialSize", data, "POST_JSON");
// 删除自定义素材尺寸
export const delMaterialSize = (data) => request("/material/delMaterialSize", data, "POST");

//素材测试信息同步
export const queryMaterialInfo = (data) => request("/material/queryMaterialInfo", data, "POST_JSON");
export const modifyMaterialStatus = (data) => request("/material/modifyMaterialStatus", data, "POST_JSON");
export const queryOperator = (data) => request("/material/queryOperator", data, "GET");
export const queryMaterialNames = (data) => request("/material/queryMaterialNames", data, "GET");
export const queryOperateLog = (data) => request("/material/queryOperateLog", data, "GET");
